
const initialState = {
	access: undefined,
	playerID: undefined,
	playerName: undefined,
	playerRole: undefined,
      games: {},
      game: undefined,
	transition_message: undefined,
      serverError: undefined,


	/* Game State */
	inGame: false,
      activeGame: false,
	dictator: "",
	fascists: [],
	liberals: [],
	lawChoices: [],
	players: {},
	assassinated_players: [],
	num_fascist_laws_passed: 0,
	num_liberal_laws_passed: 0,
	player_investigated: undefined,
}

export default (state = initialState, action) => {

	var newState = Object.assign({}, state)

      newState.serverError = undefined;

	switch (action.type) {
		case 'ACCESS_DENIED':
			newState.access = "denied";
                  newState.serverError = action.serverError;
			return newState;
            case 'SERVER_ERROR':
                  newState.serverError = action.serverError;
                  return newState;
		case 'ACCESS_GRANTED':
			newState.access = "granted";
			newState.playerName = action.playerName;
			newState.playerID = action.playerID;
                  newState.game = action.game;
			return newState;
            case 'GAMES_LIST_UPDATED': 
                  newState.games = action.games || {};
                  return newState;
		case 'PLAYERS_UPDATED':
			newState.players = action.players;
			return newState;
		case 'SET_PEEK_CARDS':
			newState.peek_cards = action.cards;
			return newState;
		case 'START_GAME':
			newState.access = "granted";
			newState.playerRole = action.role;
			newState.dictator = action.dictator;
			newState.fascists = action.fascists;
			return newState;
		case 'UPDATE_GAME':
                  newState.activeGame = action.data.active;
			// Game state (NOMINATION, VOTING, etc...)
			newState.state = action.data.state;
			// And Array of the current laws being decided between
			// newState.lawChoices = action.data.lawChoices;
			// Laws passed i.e. Current Score
			newState.num_fascist_laws_passed = action.data.num_fascist_laws_passed;
			newState.num_liberal_laws_passed = action.data.num_liberal_laws_passed;
			// A Boolean Array of who has voted
			newState.player_voted = action.data.player_voted;
			// The Actual Votes
			// The Current President + Chancellor
			newState.president = action.data.president;
			newState.chancellor = action.data.chancellor;
			newState.nominated_chancellor = action.data.nominated_chancellor;
			// Previous Government
			newState.previous_government = action.data.previous_government;
			// Failed Government Count
			newState.failed_government_count = action.data.failed_government_count;
			// Players Who Are Dead
			newState.assassinated_players = action.data.assassinated_players;
			//
			newState.presidential_power = action.data.presidential_power;
			newState.winners = action.data.winners;
			newState.win_reason = action.data.win_reason || "";
			return newState;
		case 'SET_TRANSITION':
			newState.transition_message = action.message;
			return newState;
		case 'UPDATE_LAW_CHOICES':
			newState.lawChoices = action.laws;
			return newState;
		case 'UPDATE_VOTES':
			newState.votes = action.votes;
			return newState;
		case 'PLAYER_INVESTIGATED':
			newState.player_investigated = action.player;
			return newState;
		case 'RESET_GAME':
			// newState = initialState;
			return newState;
            case 'LEAVE_GAME':
                  newState.game = undefined;
                  newState.access = undefined;
                  return newState;
            case 'OPEN_GAME_LOBBY':
                  newState.game = action.game;
                  return newState;
		default:
			return newState;
	}
}